import TechSkillsCards from "./TechSkills";
import React from "react";

const SkillsCards: React.FC = () => {
  return (
    <>
      <div>
        <h2
          className="text-lg font-medium p-0 m-0 tracking-wide
        uppercase text-gray-400 after:w-32 after:h-line-title after:inline-block after:bg-blue-400 
        after:mt-1 after:mb-1 after:ml-1 after:mr-1"
        >
          Skills
        </h2>
      </div>

      <TechSkillsCards />
    </>
  );
};

export default SkillsCards;
